module.exports = __webpack_public_path__ + "static/media/notification_alert_icon.d4a87b8c.svg";